var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGradientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 5.40002H9.3999V9.40002H5.3999V11.4H9.3999V15.4H11.3999V11.4H15.3999V9.40002H11.3999V5.40002ZM10.3999 0.400024C4.8799 0.400024 0.399902 4.88002 0.399902 10.4C0.399902 15.92 4.8799 20.4 10.3999 20.4C15.9199 20.4 20.3999 15.92 20.3999 10.4C20.3999 4.88002 15.9199 0.400024 10.3999 0.400024ZM10.3999 18.4C5.9899 18.4 2.3999 14.81 2.3999 10.4C2.3999 5.99002 5.9899 2.40002 10.3999 2.40002C14.8099 2.40002 18.3999 5.99002 18.3999 10.4C18.3999 14.81 14.8099 18.4 10.3999 18.4Z",
    fill: "url(#paint0_linear_3234_1355)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3234_1355",
    x1: 17,
    y1: -2.49988,
    x2: 2.5,
    y2: 22.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18397A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGradientIcon);
export default __webpack_public_path__ + "static/media/plus-gradient-icon.e7593cd7fa3133e61a8eef085d127c43.svg";
export { ForwardRef as ReactComponent };